import { render } from "./UpdatePods.vue?vue&type=template&id=46ccdd1d"
import script from "./UpdatePods.vue?vue&type=script&lang=js"
export * from "./UpdatePods.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__